import React from 'react';
import { PropTypes } from 'prop-types';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

export default function DownloadBtns({
  handlePdf, handleXcl, floatSide, handleSummary,
}) {
  return (
    <Button.Group style={{ float: floatSide }}>
      <Button title="Download as PDF" type="primary" icon={<DownloadOutlined />} color="green" onClick={handlePdf}>PDF</Button>
      <Button title="Download as Excel" type="primary" icon={<DownloadOutlined />} onClick={handleXcl}>XLS</Button>
      {handleSummary && (
      <Button
        title="Download as PDF"
        type="primary"
        icon={<DownloadOutlined />}
        onClick={handleSummary}
      >
        Summary
      </Button>
      )}
    </Button.Group>
  );
}

DownloadBtns.propTypes = {
  handlePdf: PropTypes.func.isRequired,
  handleXcl: PropTypes.func.isRequired,
  floatSide: PropTypes.string,
  handleSummary: PropTypes.func,
};

DownloadBtns.defaultProps = {
  floatSide: null,
  handleSummary: null,
};
